import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import { useAppTheme } from "hooks/useAppTheme";
import { ThemeSelector } from "../ThemeSelector/ThemeSelector";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const ThemeDialog = ({ open, onClose }: Props) => {
  const theme = useAppTheme();
  const { t } = useTranslation();
  return (
    <Dialog
      modalType="modal"
      open={open}
      onOpenChange={() => {
        onClose();
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            style={{
              display: "flex",
              alignItems: "center",
              color: theme.palette.purpleDark,
              gap: "5px",
            }}
          >
            {t("hbh.customizeYourTheme.label")}
          </DialogTitle>
          <DialogContent>
            <ThemeSelector />
          </DialogContent>
          <DialogActions
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Button appearance="secondary" onClick={onClose}>
              {t("greco.cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
